'use client';
import { jsxs, jsx } from '@emotion/react/jsx-runtime';
import { Stack } from '@s7/layout';
import { Typography } from '@s7/ui';

var SearchFallback = function(props) {
    var title = props.title, description = props.description;
    return /*#__PURE__*/ jsxs(Stack, {
        spacing: 8,
        sx: {
            padding: "0 2rem"
        },
        children: [
            title && /*#__PURE__*/ jsx(Typography, {
                color: "text.secondary",
                size: "md1",
                variant: "heading",
                children: title
            }),
            description && /*#__PURE__*/ jsx(Typography, {
                color: "text.tertiary",
                size: "sm1",
                children: description
            })
        ]
    });
};

export { SearchFallback };
